// Helper events client-side : POST /api/event qui forwarde vers Matomo
// server-side. A utiliser pour les actions qui n'existent QUE cote navigateur.
// Les actions metier (Membre - Ajout, Relation - Ajout, etc.) sont deja
// trackees cote BACKEND dans les routes Express (plus robuste contre les adblockers).

import axios from 'axios';

const VISITOR_ID_KEY = 'pv_visitor_id';

const getApiUrl = (): string => {
  const env = process.env.REACT_APP_API_URL;
  if (env) return env;
  const host = window.location.hostname;
  return `http://${host}:4010/api`;
};

function getVisitorId(): string | null {
  try {
    if (typeof localStorage === 'undefined') return null;
    const id = localStorage.getItem(VISITOR_ID_KEY);
    return id && /^[a-f0-9]{16}$/.test(id) ? id : null;
  } catch {
    return null;
  }
}

function ignored(): boolean {
  if (typeof document === 'undefined') return false;
  return document.cookie.includes('matomo_ignore=1');
}

interface EventOptions {
  name?: string;
  value?: number;
  props?: Record<string, string | number | boolean>;
}

/**
 * Envoie un event custom au backend (Matomo). Fire-and-forget.
 */
export function trackEvent(category: string, action: string, opts: EventOptions = {}): void {
  if (!category || !action) return;
  if (ignored()) return;

  const vid = getVisitorId();
  const body: Record<string, unknown> = { category, action };
  if (opts.name !== undefined) body.name = String(opts.name);
  if (typeof opts.value === 'number' && Number.isFinite(opts.value)) body.value = opts.value;
  if (opts.props && typeof opts.props === 'object') body.props = opts.props;
  if (vid) body.vid = vid;

  axios.post(`${getApiUrl()}/event`, body).catch(() => {});
}
